import { render, staticRenderFns } from "./filter_booking_type.vue?vue&type=template&id=678e7ea8"
import script from "./filter_booking_type.vue?vue&type=script&lang=js"
export * from "./filter_booking_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports